// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__MBgVH","additionalInfo":"AgreementModal_additionalInfo__1KX5A"};